import React, { Component } from 'react';

import NumberedCheckbox from 'Components/NumberedCheckbox';
import pageAttachedLogo from 'Assets/img/page-attached.svg';

import PropTypes from 'prop-types';
import './PageBox.scss';

export default class PageBox extends Component {
  constructor(props) {
    super(props);
    this.attachBindings();
  }

  attachBindings() {
    this.handleImageSelection = this.handleImageSelection.bind(this);
  }

  handleImageSelection(currentIndex) {
    this.props.updatePageSelectionIndex(currentIndex,this.props.id);
    this.props.updateCurrentSelectedImageIndex(currentIndex);
  }

  render() {
    let formattedClassname = '';
    let imageCheckBoxRequiredflag = this.props.page.documentType === 'Docs to the Issuer-no conversion' && this.props.imageCheckBoxRequired;
    let checkboxSelected= this.props.page.documentType === 'Docs to the Issuer-no conversion' ?true :false;
    if (this.props.canvasSelectedIndex === this.props.page.pageId) { formattedClassname = 'page-box-selected'; }
    // else if(this.props.imageStyle===true)
    // formattedClassname ='image-display'
    else { formattedClassname = 'page-box-unselected'; }

    return (
      <div className="page-box-wrapper">
        {this.props.imageCheckBoxRequired && this.props.page.documentType !== 'Docs to the Issuer-no conversion' && (
          <div className="check-box">
            <NumberedCheckbox
              currentIndex={this.props.currentIndex}
              page={this.props.page}
              toggleSelectedPage={this.props.toggleSelectedPage}
              selectAllFlag={this.props.selectAllFlag}
            />
          </div>
        )}
         {imageCheckBoxRequiredflag && (
          <div className="check-box">
            <NumberedCheckbox
              currentIndex={this.props.currentIndex}
              page={this.props.page}
              selectAllFlag={this.props.selectAllFlag}
              checkboxSelected={checkboxSelected}
            />
          </div>
        )}
        <div role="button" tabIndex="-1" onKeyDown={() => this.handleImageSelection(this.props.pageIndex)} onClick={() => this.handleImageSelection(this.props.pageIndex)} className={formattedClassname}>
          <img alt="content" width="100%" height="100%" src={this.props.page.pageContent} />
        </div>
        {this.props.imageCheckBoxRequired && this.props.page.documentType !== 'Docs to the Issuer-no conversion' && (
          <div className="page-number">
            {this.props.page.pageId + 1}
          </div>
        )}
        {imageCheckBoxRequiredflag && (
         <div className="page-number">
            {this.props.page.pageId + 1}
          </div>
        )}

        {this.props.summaryData != undefined && this.props.summaryData && this.props.summaryData.length > 0 && this.props.summaryData.map((caseRow) => {
          return (
            caseRow.clear == false &&
            caseRow.pages.map((casePage) => {
              return (
                casePage.pageId === this.props.page.pageId &&
                <img
                  src={pageAttachedLogo}
                  alt="Page Attached"
                  className="page-attached-logo"
                  key={casePage.pageId}
                />
              );
            })
          );
        }
        )}
      </div>
    );
  }
}

PageBox.propTypes = {
  currentIndex: PropTypes.number.isRequired,
  imageCheckBoxRequired: PropTypes.bool,
  pageIndex: PropTypes.number.isRequired,
  page: PropTypes.object.isRequired,
  toggleSelectedPage: PropTypes.func.isRequired,
  canvasSelectedIndex: PropTypes.number,
  updatePageSelectionIndex: PropTypes.func,
  selectAllFlag: PropTypes.bool,
  updateCurrentSelectedImageIndex: PropTypes.func
};
PageBox.defaultProps = {
  imageCheckBoxRequired: true,
  updatePageSelectionIndex: () => {},
  canvasSelectedIndex: null,
  selectAllFlag: false,
  updateCurrentSelectedImageIndex: () => {}
};
